import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "col-sm-12" }
const _hoisted_2 = { class: "card card-body" }
const _hoisted_3 = { class: "overflow-auto" }
const _hoisted_4 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_5 = { class: "text-capitalize-first" }
const _hoisted_6 = { class: "text-capitalize-first" }
const _hoisted_7 = { class: "text-capitalize-first" }
const _hoisted_8 = { class: "text-capitalize-first" }
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "text-end" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_AccountOperations = _resolveComponent("AccountOperations")!
  const _component_WithdrawalForm = _resolveComponent("WithdrawalForm")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("table", _hoisted_4, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.helper.trans('labels.id')), 1),
                  _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.helper.trans('labels.currency')), 1),
                  _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.helper.trans('labels.sum')), 1),
                  _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.helper.trans('dashboard.on_hold')), 1),
                  _cache[4] || (_cache[4] = _createElementVNode("th", null, null, -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountItems, (account) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: account.id,
                    class: ""
                  }, [
                    _createElementVNode("td", null, [
                      _withDirectives((_openBlock(), _createElementBlock("span", {
                        title: account.id
                      }, [
                        _createTextVNode(_toDisplayString(account.id.substring(0, 8)) + "...", 1)
                      ], 8, _hoisted_9)), [
                        [
                          _directive_b_tooltip,
                          void 0,
                          void 0,
                          { hover: true }
                        ]
                      ]),
                      _cache[5] || (_cache[5] = _createTextVNode()),
                      _createVNode(_component_copy_button, {
                        value: account.id
                      }, null, 8, ["value"])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(account.currency), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(account.sum)), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(account.frozenSum)), 1),
                    _createElementVNode("td", _hoisted_10, [
                      (_ctx.store.getters.hasPermission(_ctx.UserPermission.WITHDRAW_FROM_SYSTEM_ACCOUNT))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _withModifiers(($event: any) => (_ctx.withdrawAccount = account), ["prevent"]),
                            class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize-first me-2"
                          }, [
                            _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fa-solid fa-upload" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.helper.trans("button.withdraw")), 1)
                          ], 8, _hoisted_11))
                        : _createCommentVNode("", true),
                      (_ctx.accountForDetails !== null)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.accountForDetails = null), ["prevent"])),
                            class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                          }, [
                            _cache[7] || (_cache[7] = _createElementVNode("i", { class: "fa fa-arrow-left" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.back')), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            onClick: _withModifiers(($event: any) => (_ctx.accountForDetails = account), ["prevent"]),
                            class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize-first"
                          }, _toDisplayString(_ctx.helper.trans("menu.items.accountOperations")), 9, _hoisted_12))
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      (_ctx.accountForDetails)
        ? (_openBlock(), _createBlock(_component_AccountOperations, {
            key: 0,
            account: _ctx.accountForDetails,
            class: _normalizeClass('m-0')
          }, null, 8, ["account"]))
        : _createCommentVNode("", true),
      _createVNode(_component_b_modal, {
        title: _ctx.helper.trans('labels.withdrawal'),
        modelValue: _ctx.withdrawAccount !== null,
        "header-class": "text-capitalize",
        "body-class": "pt-0",
        "footer-class": "d-flex justify-content-between",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($event === false && (_ctx.withdrawAccount = null)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_WithdrawalForm, {
            ref: "withdrawalForm",
            account: _ctx.withdrawAccount
          }, null, 8, ["account"])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.withdrawAccount = null)),
            class: "btn btn-outline-dark btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans("button.cancel")), 1),
          _createVNode(_component_LoaderWrapper, {
            ref: "loaderWithdrawalForm",
            zoom: 0.5
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createWithdraw())),
                class: "btn btn-outline-primary btn-sm text-capitalize-first"
              }, _toDisplayString(_ctx.helper.trans("button.withdraw")), 1)
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      }, 8, ["title", "modelValue"])
    ]),
    _: 1
  }, 512))
}